// extracted by mini-css-extract-plugin
export var searchHeader = "_63-0";
export var searchHeaderDark = "_63-1";